// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ufvag","left":"styles_left__ppp2L","desktopActions":"styles_desktopActions__2YmyO","title":"styles_title__McZ_b"};